import React, { useEffect } from "react";
import {
  Table,
  Button,
  Row,
  Col,
  Input,
  Tooltip,
  Select,
  Modal,
  Divider,
  Card,
  Typography,
  Popconfirm,
  DatePicker,
  Popover,
} from "antd";
import dayjs from "dayjs";
import { useAdminReport } from "../../Hooks/Admin/useReport";
import { useDispatch } from "react-redux";
import { useAdminInvoices } from "../../Hooks/Admin/useInvoices";
import { EditOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";

const { Text } = Typography;

const Index = () => {
  const dispatch = useDispatch();
  const { getReports, updateSalary } = useAdminReport();
  const { getAllUser } = useAdminInvoices();

  useEffect(() => {
    get_report_data();
  }, []);

  React.useEffect(() => {
    get_all_users();
  }, []);

  const [userList, setuserList] = React.useState([]);

  const get_all_users = async () => {
    try {
      const data = await getAllUser(dispatch);
      if (data.length > 0) {
        const arr = [];
        data.map((item) => {
          arr.push({ label: item.name, value: item.id });
        });
        setuserList(arr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [salaryTableData, setsalaryTableData] = React.useState([]);
  const [salaryTableCount, setsalaryTableCount] = React.useState("");

  const get_report_data = async () => {
    try {
      const salaryArr = [];
      const data = await getReports({}, dispatch);
      console.log(data.data);
      if (data.data.length > 0) {
        data.data.map((item) => {
          salaryArr.push({
            user: item.user_id,
            amount: item.salary,
          });
        });
        const sortedsalary = [...salaryArr].sort((a, b) => b.amount - a.amount);
        setsalaryTableData(sortedsalary);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const salaryColumns = [
    {
      title: "Name",
      dataIndex: "user",
      key: "user",
      align: "center",
      render: (text, record) => {
        return (
          <div>{userList.filter((item) => item.value === text)[0]?.label}</div>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "center",
    },
    {
      title: "",
      key: "action",
      align: "center",
      render: (text, record) => {
        return (
          <Popover
            onOpenChange={() => {
              setsalaryTableCount("");
            }}
            content={
              <div style={{  }}>
                <div style={{marginBottom:"10px",fontWeight:"bold"}} >
                  {"Update Salary " +
                    `(${
                      userList.filter((item) => item.value === record.user)[0]
                        ?.label
                    })`}
                </div>
                <Input
                  onChange={(e) => {
                    setsalaryTableCount(e.target.value);
                  }}
                  value={salaryTableCount}
                  placeholder="Enter Amount"
                />
                <Button
                  type="primary"
                  style={{ marginTop: "10px", width: "100%" }}
                  onClick={async () => {
                    try {
                      const data = await updateSalary(
                        {
                          user_id: record.user,
                          salary: salaryTableCount,
                        },
                        dispatch
                      );
                      console.log(data);
                      toast.success(data.message);
                      get_report_data();
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  Update
                </Button>
              </div>
            }
            trigger="hover"
            placement="right"
          >
            <EditOutlined />
          </Popover>
        );
      },
    },
  ];

  return (
    <div>
      {/* <Row style={{ marginBottom: "20px" }} gutter={[16, 24]}>
        <Col span={6}>
          <Select
            size="large"
            style={{ width: "100%" }}
            placeholder="Select Months"
            defaultValue={""}
            onChange={(e) => {
              setselectedMonth(e);
            }}
            options={[
              { value: "", label: "All Months" },
              { value: "1", label: "January" },
              { value: "2", label: "February" },
              { value: "3", label: "March" },
              { value: "4", label: "April" },
              { value: "5", label: "May" },
              { value: "6", label: "June" },
              { value: "7", label: "July" },
              { value: "8", label: "August" },
              { value: "9", label: "September" },
              { value: "10", label: "October" },
              { value: "11", label: "November" },
              { value: "12", label: "December" },
            ]}
          ></Select>
        </Col>
        <Col span={6}>
          <DatePicker
            style={{ width: "100%" }}
            size="large"
            maxDate={dayjs()}
            defaultValue={dayjs()}
            format={"YYYY"}
            onChange={(date, dateString) => {
              setselectedYear(dateString);
            }}
            picker="year"
          />
        </Col>
      </Row> */}
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: "1px solid #f0f0f0",
              padding: "0 10px",
              borderRadius: "5px",
            }}
          >
            <h3>Salary</h3>
          </div>
          <Table
            columns={salaryColumns}
            dataSource={salaryTableData}
            pagination={false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Index;
